import React, { useState } from 'react';
import { Box } from '@styleseat/ui';
import {
  Touchable,
  Stack,
  BodyText,
} from '../../../ui';
import { Popover } from '../../../ui/Popover';
import { BasicSettingsIcon } from '../../../ui/Icons/BasicSettingsIcon';
import StateLink from '../../../StateLink';
import type { PrivilegedProvider } from '../../../../api/Providers';

export type AdminMenuProps = {
  profile: Pick<PrivilegedProvider, 'name' | 'plan' | 'id'>;
};

const AdminMenu = ({
  profile,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Box position="relative">
      <Touchable onClick={() => setMenuOpen(true)} testID="adminMenuIcon">
        <Box>
          <BasicSettingsIcon />
        </Box>
      </Touchable>
      {!menuOpen ? null : (
        <Popover
          name="adminMenu"
          onClose={() => setMenuOpen(false)}
          position="menu"
          top={28}
          right={0}
        >
          <Stack padding={20} space={20}>
            <BodyText whiteSpace="nowrap">Name: {profile.name}</BodyText>
            <BodyText whiteSpace="nowrap">Plan: {profile.plan}</BodyText>
            <BodyText whiteSpace="nowrap">ID: {profile.id}</BodyText>
            <StateLink
              href={`/ssadminx/provider/provider/${profile.id}/`}
              style={{ textDecoration: 'none' }}
              testID="adminLink"
            >
              <BodyText whiteSpace="nowrap">Admin Link</BodyText>
            </StateLink>
          </Stack>
        </Popover>
      )}
    </Box>
  );
};

export default AdminMenu;
